import { render, staticRenderFns } from "./EmailCampaings.vue?vue&type=template&id=2041d5bc"
import script from "./EmailCampaings.vue?vue&type=script&lang=js"
export * from "./EmailCampaings.vue?vue&type=script&lang=js"
import style0 from "./EmailCampaings.vue?vue&type=style&index=0&id=2041d5bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports